export { default } from './DocumentExpirationDates';
